module.exports = __webpack_public_path__ + "assets/img/IE-Logo.fc32c84e.png";